import { useEffect, useRef } from 'react';
import Volanta from '@/components/Volanta';
import Image from 'next/image';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import useMediaQuery from '@/hooks/useMediaQuery';
import HopName from '@/components/Svgs/hopname';

gsap.registerPlugin(ScrollTrigger);

const SomosPortrait = ({ description }) => {
  const section = useRef(null);
  const isMobile = useMediaQuery('max-width: 650px');

  return (
    <section ref={section} className="relative w-full py-100">
      <div className="flex items-center justify-center w-full h-full mb-80">
        <div className="mr-10">
          <h2 className="title-2 !text-24 sm:t!ext-48 text-cyan-dark phrase-js">Simple, rápido,</h2>
        </div>
        <div className="w-165 sm:w-400">
          <HopName />
        </div>
      </div>
      <div className="site-grid">
        <div className="col-span-4 sm:col-start-2 sm:col-span-2">
          <div className="mb-65 opacity-90">
            <Volanta label="¿Quiénes somos?" />
          </div>
          <div>
            <h3 className="title-3 text-cyan-dark">
                { description }
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};
export default SomosPortrait;
